module.exports = __webpack_public_path__ + "media/components/src/assets/images/user_info/content-a235cf05a553201764503c36d601fe30.svg";